<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { notify } from 'src/plugins/notify'

export default {
  name: 'MigrateInstructor',
  mounted () {
    let vm = this
    vm.setMigrateInstructor()
  },
  data () {
    return {
      instructorFilter: '',
      currentInstructorLabel: ''
    }
  },
  computed: {
    ...mapState('users', {
      migrateOpen: s=> s.migrateOpen,
      selectedMigrateInsturctor: s => s.selectedMigrateInsturctor,
      migratingInstructor: s => s.migratingInstructor
    })
  },  
  methods: {
    ...mapMutations('users', [
      'setMigrateOpen',
      'setMigrateInstructor'
    ]), 
    ...mapActions('users', [
      'migrateInstructor',
    ]),    
    ...mapActions('classes',[
      'instructorAutocomplete'
    ]),
    onClose(){
      this.setMigrateOpen(false)
    },
    onMigrate(){
      if(!this.selectedMigrateInsturctor) return notify.create({message:"Please Select Instructor!", type:"negative"})
      this.migrateInstructor()
    },
    onSelectInstructor(selectedInstructor){
      let vm = this
      vm.setMigrateInstructor(selectedInstructor)
      vm.currentInstructorLabel = selectedInstructor ? selectedInstructor.value : null
    }, 
    async onInstructorAutocomplete(s, done){
      let vm = this
      let results = await this.instructorAutocomplete(s)
      vm.currentInstructorLabel = (results.length == 0 && !vm.currentInstructorLabel) ? 'No Matching Instructors' : vm.currentInstructorLabel
      done(results)
    },
  }
}

</script>

<template>
  <q-modal
    v-model="migrateOpen"
    class="sl-modal"
    :content-css="{minWidth: '30vw'}"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-icon name="call_merge"></q-icon>
        <q-toolbar-title>
          Migrate Instructor
        </q-toolbar-title>
        <q-icon @click.native="onClose" name="clear" :disabled="migratingInstructor" />
      </q-toolbar>
 
      <div class="layout-padding">
        <q-field :helper="currentInstructorLabel">
          <q-input float-label="Instructor" :clear-value="null" clearable @clear="onSelectInstructor()" v-model="instructorFilter">
            <q-autocomplete                      
              :debounce="500"
              float-label="Instructor"
              :max-results="10"
              @search="onInstructorAutocomplete"
              @selected="onSelectInstructor"
            />
          </q-input>
        </q-field>
        <div class="panel text-center">
          <q-icon name="fa fa-warning" size="30px" /> <b>Warning</b>
          <p>The selected instructor will replace this affiliates instructor.</p>
          <p>All classes will be merged with the existing instructor if one exists.</p>
          <p><b>THIS CANNOT BE UNDONE.</b></p>
        </div>
        
      </div>   
      <q-toolbar slot="footer">
        <q-toolbar-title>
        </q-toolbar-title>        
        <q-btn outline color="faded" @click.native="onClose" :disabled="migratingInstructor" label="Cancel" />&nbsp;  
        <q-btn outline color="primary" @click.native="onMigrate" :loading="migratingInstructor" :disabled="migratingInstructor" label="Migrate" />          
      </q-toolbar>
    </q-modal-layout>
    <q-inner-loading :visible="migratingInstructor">
        <q-spinner-gears color="primary" size="70"></q-spinner-gears>
        <span>Migrating</span>
    </q-inner-loading>
  </q-modal>
</template>

<style lang="css">

</style>
